//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[0,"CreateEndToStart",1,0],[1,"EndPath",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"OffsetAlongNormal",0,"Expression",0],[1,"OffsetInFace",0,"Expression",0],[0,"OffsetMethod",1,0],[1,"PathSection",0,"Section",0],[0,"ReverseOffsetDirection",1,0],[1,"StartPath",0,"GeometricUtilities.OnPathDimensionBuilder",0]],[[["pointFound","evaluationPoint","pathTangent","faceNormalWithFin","faceNormalOppositeFin"],"UpdatePath",{},0,0],[[],"GetSweepPath",{R_:{sweepPathCurve:"Spline"}},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Weld.WeldBeadPathBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.WeldBeadPathBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.WeldBeadPathBuilder.OffsetMethodType = Object.freeze({
    "InFace" : "InFace", "Centerline" : "Centerline"});

export default SPLM;